import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import { SAVE_MODELS } from "@/store/mutation-types";

export default {
  actions: {
    loadProjectModels: async ({ commit }, payload) => {
      let models;
      return ApiRequest.exploreGet(
        "projects/" + payload.id + "/models",
        GetHeaders.projectHeaders()
      ).then(res => {
        models = res.data;
        commit(SAVE_MODELS, { models: models });
        return models;
      });
    },
    loadModel: async (_, payload) => {
      return ApiRequest.exploreGet(
        "models/" + payload.id,
        GetHeaders.projectHeaders()
      ).then(res => {
        if (res.status === 401) {
          alert("Unauthorized");
          return;
        }
        return res.data;
      });
    },
    processModel: async (_, payload) => {
      return ApiRequest.explorePost(
        "process" + "?method=" + payload.method + "&_id=" + payload.modelId,
        null,
        GetHeaders.projectHeaders()
      );
    },
    updateModel: async (_, payload) => {
      return ApiRequest.explorePost(
        "models/" + payload.modelId,
        payload.model,
        GetHeaders.projectHeaders()
      );
    },
    removeModel: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "models/" + payload.id,
        GetHeaders.projectHeaders()
      ).then(() => {
        dispatch("loadPools");
      });
    },
    addPoolToModel: async (_, payload) => {
      return ApiRequest.explorePost(
        "projects/" +
          payload.projectId +
          "/models/" +
          payload.modelId +
          "/subpool",
        {
          pool_id: payload.poolId,
          documents: [],
          filter: []
        },
        GetHeaders.projectHeaders()
      ).catch(response => {
        console.log(response);
      });
    },
    removePoolFromModel: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "projects/" +
          payload.projectId +
          "/models/" +
          payload.modelId +
          "/subpool/" +
          payload.poolId,
        GetHeaders.projectHeaders()
      )
        .then(() => {
          dispatch("loadPools");
        })
        .catch(error => {
          return error.response;
        });
    },
    addUserToModel: async (_, payload) => {
      return ApiRequest.explorePost(
        "projects/" +
          payload.projectId +
          "/models/" +
          payload.modelId +
          "/users/" +
          payload.userId,
        null,
        GetHeaders.projectHeaders()
      );
    },
    removeUserFromModel: async ({ dispatch }, payload) => {
      return ApiRequest.exploreDelete(
        "projects/" +
          payload.projectId +
          "/models/" +
          payload.modelId +
          "/users/" +
          payload.userId,
        GetHeaders.projectHeaders()
      )
        .then(() => {
          dispatch("loadProjectModels", { id: payload.projectId });
        })
        .catch(error => {
          return error.response;
        });
    }
  },
  mutations: {
    [SAVE_MODELS](state, payload) {
      state.projectModels = payload.models;
    }
  },
  state: {
    projectModels: []
  }
};
